function rotateIcon() {
  var icon = document.getElementById('togleIcon');
  icon.classList.toggle('rotated');
}